import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import SchedulePageShell from './SchedulePageShell';
import useModals from './hooks/useModals';
import useSnackbar from 'common/hooks/useSnackbar';
import useScheduleSockets from './hooks/useScheduleSockets';
import { isMobileSchedule } from 'helpers/_helpers';

/**
 * Top-level container for the v6 schedule.
 *
 * Responsibilities:
 * - initialize sockets, snackbar, and modals (shared for both mobile and desktop)
 * - read schedule-related state from Redux
 * - delegate rendering to SchedulePageShell
 */
const ScheduleV6Page = () => {
  useScheduleSockets();

  const scheduleState = useSelector((state) => state.schedule);
  const {
    selectedDate,
    scheduleDayView,
    scheduleView,
    showAllLocations,
    filters,
  } = scheduleState;

  const organizationSettings = useSelector(
    (state) => state.personalProfile.organization?.settings || {}
  );

  const { openSnackbar, renderSnackbar } = useSnackbar();
  const { initModals, cleanupModals, openModal } = useModals();

  useEffect(() => {
    initModals();
    return () => {
      cleanupModals();
    };
  }, []);

  const { dateFormat, timeFormat } = organizationSettings;
  const isMobile = isMobileSchedule();

  return (
    <>
      <SchedulePageShell
        isMobile={isMobile}
        selectedDate={selectedDate}
        scheduleDayView={scheduleDayView}
        scheduleView={scheduleView}
        showAllLocations={showAllLocations}
        filters={filters}
        dateFormat={dateFormat}
        timeFormat={timeFormat}
        openSnackbar={openSnackbar}
        openModal={openModal}
      />
      {renderSnackbar()}
    </>
  );
};

export default ScheduleV6Page;
